<template>
    <section class="row-12">
        <folder-list folderType="conspects" @select-folder="changeFolder" ref="folders" class="col-12"></folder-list>

        <h2 class="col-4 col-sm-12" v-if="activeFolder">Projekty z folderu "{{activeFolder.name}}"</h2>
        <h2 class="col-4 col-sm-12" v-else>Nie wybrano folderu</h2>

        <div class="col-8 col-sm-12">
            <div class="row-12 m-t-2">
                <div class="col-3 col-sm-12 input-with-icon-close center-flex-y">
                    <input id="calendarPickerFrom" class="calendarPicker" placeholder="Data od"/>
                    <i class="i-calendar"></i>
                    <i class="i-cross" @click="removeData('#calendarPickerFrom')"></i>
                </div>
                <div class="col-3 col-sm-12 input-with-icon-close center-flex-y">
                    <input id="calendarPickerTo" class="calendarPicker" placeholder="Data do"/>
                    <i class="i-calendar"></i>
                    <i class="i-cross" @click="removeData('#calendarPickerTo')"></i>
                </div>
                <div class="col-6 col-sm-12 input-with-icon">
                    <input id="searchFilter" v-model="inputText" placeholder="Wyszukaj..."/>
                    <i class="i-search"></i>
                </div>
            </div>
        </div>
        <div class="col-12 m-t-1 m-b-5">
            <div class="row-12" v-if="filteredList.length > 0">
                <div class="card col-4 col-sm-12 col-md-6 wow fadeIn" v-for="conspect in conspectList"
                     :key="conspect.id">
                    <div class="card-body" style="padding-right:50px;">
                        <div class="row-12">
                            <div class="col-12 center-flex-a" style="justify-content: flex-start">
                                <i class="i-calendar text-primary i-md"></i>
                                <small> {{conspect.date}}</small>
                            </div>
                        </div>
                        <h4 class="m-t-4 m-b-2">{{conspect.title}}</h4>
                        <p class="m-y-1" style="min-height: 48px;" v-if="conspect.description.length > 0">
                            {{conspect.description}} </p>
                        <p class="m-y-1" style="min-height: 48px;" v-else> Ten projekt nie posiada opisu. Przejdź do
                            edycji, aby go uzupełnić.</p>
                        <div class="side-menu" style="height: 100%;">
                            <c-sidemenu
                                    :icon="'i-sm i-compose'"
                                    @click.native="goToEditConspect(conspect.id)"
                                    :links="[{name: 'Edytuj'}]"
                            />
                            <c-sidemenu
                                    :icon="'i-sm i-download'"
                                    @click.native="downloadConspectModal(conspect.id, conspect.title)"
                                    :links="[{name: 'Pobierz'}]"
                            />
                            <c-sidemenu
                                    :icon="'i-sm i-share'"
                                    @click.native="shareModal(conspect.id)"
                                    :links="[{name: 'Udostępnij'}]"
                            />
                            <c-sidemenu
                                    :icon="'i-sm i-cross'"
                                    @click.native="deleteConspect(conspect.id)"
                                    :links="[{name: 'Usuń'}]"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12" v-else>
                <error-notifier
                        type="info"
                        title="Brak konspektów do wyświetlenia"
                        message="Nie stworzyłeś jeszcze żadnych konspektów, które moglibyśmy tu wyświetlić."
                />
            </div>
        </div>
        <div class="modal" id="modalDowloadConspect">
            <div class="modal-header">
                Pobierz konspekt w odpowiadającym Ci formacie.
            </div>
            <div class="modal-body">
                <div class="card">
                    <div class="card-body" style="position: relative;">
                        <button class="select-button-in-card" @click="downloadConspect('pzpn-theme')">Wybierz</button>
                        <h3>Format PZPN</h3>
                        <p>Format w pełni zgodny z formatem konspektu PZPN</p>
                    </div>
                </div>
                <div class="card">
                    <div class="card-image" style="max-width: 450px;">
                        <img src="../../assets/sample_cmc.png" alt="CMC_THEME">
                    </div>
                    <div class="card-body" style="position: relative;">
                        <button class="select-button-in-card" @click="downloadConspect('cmc-theme')">Wybierz</button>
                        <h3>Format Club Management Center</h3>
                        <p>Nowoczesność, czytelność i prostota.</p>
                    </div>
                </div>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="denyDelete()">Anuluj</button>
            </div>
        </div>

        <div class="modal" id="modalPromptForDelete">
            <div class="modal-header">
                Nieodwracalne usunięcie konspektu
            </div>
            <div class="modal-body">
                <p>Jesteś pewny, że chcesz usunąć dany konspekt?</p>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="denyDelete()">Anuluj</button>
                <button @click="allowDelete()">Tak, usuń</button>
            </div>
        </div>
        <div class="modal" id="shareModal">
            <div class="modal-header">
                Udostępnij znajomym
            </div>
            <div v-if="!this.$vuetify.breakpoint.smAndDown" class="modal-body center-flex-a">
                <p class="text-a-c">Kliknij w daną osobę w liście znajomych, aby przenieść ją do udostępnionych, lub
                    odwrotnie</p>
                <div class="row-12">
                    <div class="col-6">
                        <div class="header-list">Lista znajomych</div>
                        <div class="left-friends-list m-y-4">
                            <div class="card m-t-1" v-for="(friend, key) in sharedData.friendsNoShared"
                                 v-on:click="addToShare(friend, key)">
                                <div class="card-body display-flex" style="position: relative;">
                                    <div class="center-flex-a" style="height: auto;">
                                        <img class="circle-profile" :src="friend.profile_img"
                                             :alt="friend.firstname">
                                    </div>
                                    <div class="p-l-4" style="width: calc(100% - 70px); align-self: center">
                                        <h5 class="text-second w-100">{{friend.firstname}}
                                            <b>{{friend.lastname}}</b></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="header-list">Udostępnione dla</div>
                        <div class="right-friends-list m-y-4">
                            <div class="card m-t-1" v-for="(shared, key) in sharedData.friendsShared">
                                <div class="card-body display-flex" style="position: relative;">
                                    <div class="center-flex-a" style="height: auto;">
                                        <img class="circle-profile" :src="shared.profile_img"
                                             :alt="shared.firstname">
                                    </div>
                                    <div class="p-l-4" style="width: calc(100% - 70px); align-self: center">
                                        <h5 class="text-second w-100">{{shared.firstname}}
                                            <b>{{shared.lastname}}</b></h5>
                                    </div>
                                    <span class="deleteFriend" @click="deleteFromShared(shared, key)">
                                        <i class="i-cross"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="modal-body center-flex-a">
                <div class="row-12">
                    <div class="col-12">
                        <p class="text-a-c">Wybierz czy chcesz udostępnić nowej osobie ("Lista znajomych") czy też
                            usunąć dostęp komuś komu już udostępniasz ("Udostępnione dla")</p>
                        <div class="share-titles">
                            <div v-on:click="changeList(true)" class="header-list">Lista znajomych</div>
                            <div v-on:click="changeList(false)" class="header-list">Udostępnione dla</div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div v-show="friends" class="center-flex-a">
                            <div class="left-friends-list m-y-4">
                                <div class="card m-t-1" v-for="(friend, key) in sharedData.friendsNoShared"
                                     v-on:click="addToShare(friend, key)">
                                    <div class="card-body display-flex" style="position: relative;">
                                        <div class="center-flex-a" style="height: auto;">
                                            <img class="circle-profile" :src="friend.profile_img"
                                                 :alt="friend.firstname">
                                        </div>
                                        <div class="p-l-4" style="width: calc(100% - 70px); align-self: center">
                                            <h5 class="text-second w-100">{{friend.firstname}}
                                                <b>{{friend.lastname}}</b></h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="!friends" class="center-flex-a">
                            <div class="right-friends-list m-y-4">
                                <div class="card m-t-1" v-for="(shared, key) in sharedData.friendsShared">
                                    <div class="card-body display-flex" style="position: relative;">
                                        <div class="center-flex-a" style="height: auto;">
                                            <img class="circle-profile" :src="shared.profile_img"
                                                 :alt="shared.firstname">
                                        </div>
                                        <div class="p-l-4" style="width: calc(100% - 70px); align-self: center">
                                            <h5 class="text-second w-100">{{shared.firstname}}
                                                <b>{{shared.lastname}}</b></h5>
                                        </div>
                                        <span class="deleteFriend" @click="deleteFromShared(shared, key)">
                                        <i class="i-cross"></i>
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#shareModal')">Anuluj</button>
            </div>
        </div>

    </section>
</template>

<script>
    import SideMenu from '../../components/CardSideMenu'
    import Search from '../../components/Search'
    import ErrorNotifier from '../../components/ErrorFullNotifier'
    import FolderList from '../../components/FolderList'

    export default {
        components: {
            'c-sidemenu': SideMenu,
            'c-search': Search,
            'error-notifier': ErrorNotifier,
            'folder-list': FolderList
        },
        data: () => {
            return {
                conspectList: [],
                elementToDeleteId: null,
                showAlphabetically: false,
                showChronological: false,
                filteredList: [],
                activeFolder: null,
                inputText: '',
                pickedDate: '',
                downloadConspId: -1,
                downloadConspName: '',
                friends: true,
                actualSharedElementId: null,
                sharedData: {
                    friendsNoShared: [],
                    friendsShared: []
                },
            };
        },
        methods: {
            changeFolder(activeFolder){
                this.activeFolder = activeFolder;
                this.$refs.folders.getContent()
                    .then((response) => {
                        this.conspectList = response;
                        this.filteredList = this.conspectList;
                    })
            },
            addToShare(friend, key) {
                axios.post(`conspect/${this.actualSharedElementId}/share/${friend.id}`)
                    .then((response) => {
                        this.sharedData.friendsNoShared.splice(key, 1);
                        this.sharedData.friendsShared.push(friend);
                        notify.createNotifier("Udostępniono pomyślnie.", "success", 2000);
                    })
                    .catch(() => {
                        notify.createNotifier("Niestety nie udało się udostępnić. Spróbuj później.", "danger", 4000);
                    });
            },
            shareModal(id) {
                axios.get(`conspect/${id}/sharedList`)
                    .then((response) => {
                        this.sharedData = {
                            friendsNoShared: response.data.friends,
                            friendsShared: response.data.shared
                        };
                        this.actualSharedElementId = id;
                        this.showModal('#shareModal');
                    })
                    .catch(() => {
                        notify.createNotifier("Niestety nie mogliśmy pobrać tych danych w tej chwili. Spróbuj za chwilke.", "danger", 4000);
                    });
            },
            deleteFromShared(friend, key) {
                axios.delete(`conspect/${this.actualSharedElementId}/share/${friend.id}`)
                    .then((response) => {
                        this.sharedData.friendsShared.splice(key, 1);
                        this.sharedData.friendsNoShared.push(friend);
                        notify.createNotifier("Cofnięto udostępnienie.", "success", 2000);
                    })
                    .catch(() => {
                        notify.createNotifier("Niestety nie udało się cofnąć udostępnienia. Spróbuj później.", "danger", 4000);
                    });
            },
            changeList(type) {
                this.friends = type;
            },
            downloadConspect(themeName) {
                axios.get(`conspect/${this.downloadConspId}/download/${themeName}`, {responseType: 'blob'})
                    .then((response) => {
                        if (response.data) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', this.downloadConspName + ".pdf");
                            document.body.appendChild(link);
                            link.click();
                            notify.createNotifier("Pobieranie pliku .pdf rozpoczęte.", "info", 2000);
                        }
                    })
                    .catch(() => {
                        notify.createNotifier("Niestety coś jest nie tak z Twoim konspektem. Prosimy spróbuj za minutę.", "danger", 4000);
                    })
            },
            goToEditConspect(id) {
                this.$router.push('editConspect/' + id);
            },
            showModal(name) {
                $(name).showModal()
            },
            hideModal(name) {
                $(name).hideModal()
            },
            removeData(name) {
                $(name).val('');
                this.filterDate(null);
            },
            denyDelete() {
                this.hideModal('#modalPromptForDelete');
                this.hideModal('#modalDowloadConspect');
            },
            allowDelete() {
                this.hideModal('#modalPromptForDelete');
                if (this.elementToDeleteId) {
                    axios.delete(`conspect/${this.elementToDeleteId}`)
                        .then((response) => {
                            notify.createNotifier("Konspekt został usunięty.", "success", 2000);
                            for (let i = 0; i < this.conspectList.length; i++) {
                                if (this.conspectList[i].id == this.elementToDeleteId) {
                                    this.conspectList.splice(i, 1);
                                    break;
                                }
                            }
                            for (let i = 0; i < this.filteredList.length; i++) {
                                if (this.filteredList[i].id == this.elementToDeleteId) {
                                    this.filteredList.splice(i, 1);
                                    break;
                                }
                            }
                            this.elementToDeleteId = null;
                        })
                        .catch(() => {
                            notify.createNotifier("Niestety cos poszło źle. Spróbuj jeszcze raz za kilka sekund.", "danger", 3000);
                        });

                }
            },
            changeFilter(type) {
                this.conspectList = this.filteredList;
                this.conspectList = type === 'alf' ? this.conspectList.sort((a, b) => a.name.localeCompare(b.name)) : this.conspectList.sort((a, b) => b.date_add.localeCompare(a.date_add));
                this.filterPractice();
                this.filterAnimation();
            },
            filterPractice() {
                this.filterAnimation(() => {
                    let input = this.inputText.toLowerCase();
                    let self = this;
                    this.filteredList = [];
                    if (input.length !== 0) {
                        this.conspectList.filter(function (item) {
                            if (item.title.toLowerCase().includes(input))
                                self.filteredList.push(item)
                        })
                    } else {
                        this.filteredList = this.conspectList;
                    }
                })
            },
            filterAnimation(callback) {
                'use strict';

                $(document).off('keyup', '#searchFilter');
                $(document).on('keyup', '#searchFilter', function (e) {
                    e.preventDefault();

                    $('.card').each(function () {
                        $(this).addClass('is-animated').stop().fadeOut(500);
                    });

                    setTimeout(() => {
                        if (callback) callback();
                        $('.card').each(function () {
                            $(this).removeClass('is-animated').addClass('is-animated-a').stop().fadeIn(500);
                        });
                    }, 550);
                });
            },
            filterDate() {
                let self = this;

                let dateFrom = $("#calendarPickerFrom").val();
                let dateTo = $("#calendarPickerTo").val();

                dateTo = (dateTo == "" ? null : moment(dateTo));
                dateFrom = (dateFrom == "" ? null : moment(dateFrom));

                this.filteredList = [];
                this.conspectList.filter(function (item) {
                    let animationsDate = moment(item.date);

                    if (dateTo && dateFrom && animationsDate.isBetween(dateFrom, dateTo, null, '[]')) {
                        self.filteredList.push(item);
                    } else if (dateTo && !dateFrom && animationsDate.isSameOrBefore(dateTo)) {
                        self.filteredList.push(item);
                    } else if (dateFrom && !dateTo && animationsDate.isSameOrAfter(dateFrom)) {
                        self.filteredList.push(item);
                    } else if (!dateFrom && !dateTo) {
                        self.filteredList.push(item);
                    }

                })
            },
            showFilters() {
                if ($('.projectsNavigation div.filterOptions').hasClass('showFilter')) {
                    $('.projectsNavigation .filterOptions').removeClass('showFilter');
                } else {
                    $('.projectsNavigation .filterOptions').addClass('showFilter');
                }
            },
            downloadConspectModal(id, name) {
                this.downloadConspId = id;
                this.downloadConspName = name.replace(" ", "_");
                this.showModal("#modalDowloadConspect");
            },
            deleteConspect(id) {
                this.elementToDeleteId = id;
                this.showModal('#modalPromptForDelete');
            }
        },
        mounted: function () {
            let self = this;

            $(document).off('keyup', '#searchFilter');
            $(document).on('keyup', '#searchFilter', this.filterPractice);

            $('.calendarPicker').datetimepicker({
                format: "Y-m-d",
                timepicker: false,
                language: 'pl-PL',
                autoclose: true,
            });

            $(document).off('change', '.calendarPicker');
            $(document).on('change', '.calendarPicker', function () {
                self.filterDate();
            });
        },
    }
</script>

<style>
    .select-button-in-card {
        position: absolute;
        top: -25px;
        left: calc(50% - 12px);
        transform: translateX(-50%);
    }

    #modalDowloadConspect .modal-body .card{
        width: 100%;
        margin-top: 50px;
    }
</style>

